import React from 'react';
import { browserHistory } from 'react-router'
import moment from 'moment';
import { Button, Checkbox, Chip, TableCell, TableRow } from '@material-ui/core';
import { checkPermission } from '../../utils_v2';
import { displayDateFormatShort } from '../../../constants';
import ReadMoreInline from '../../../shared/components/ReadMoreInline';

const daysSinceLogin = (lastLogin) => lastLogin ? moment().diff(moment(lastLogin), 'days') : null;

const getStatusInfo = (item) => {
    if (!item?.is_active) return { label: 'Deactivated', bg: '#F5E4E2', color: '#C0392B' };
    if (item?.is_new_user) return { label: 'Invitation Sent', bg: '#FBF3DD', color: '#B8860B' };
    return { label: 'Active', bg: '#E4F4EA', color: '#2E8B57' };
}

const ActiveList = ({item, onDelete, onEdit, onDeactivate,}) => {
    const days = daysSinceLogin(item?.last_login);
    const status = getStatusInfo(item);
    return(
        <TableRow onClick={() => browserHistory.push(`/users/manage/${item.slug}`)}>
            {/* {checkPermission('settings', 'manage_user','U') ?
                <TableCell padding='checkbox' onClick={(e) => e.stopPropagation()}>
                    {item?.is_active && !item?.is_new_user ?
                        <Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => toggleBulkOps(item, e.target.checked)} color='primary' size='small' />
                        : null
                    }
                </TableCell>: null
            } */}
             <TableCell style={{position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, minWidth:'170px', maxWidth:'220px'}}><ReadMoreInline text={`${item?.first_name || ''} ${item?.last_name || ''}`.trim()} /></TableCell>
            <TableCell style={{minWidth:'220px', whiteSpace:'nowrap'}}>{item?.email||'--'}</TableCell>
            <TableCell><ReadMoreInline text={`${item?.designation||'--'}`} /></TableCell>
            <TableCell style={{width:'160px'}}>{item?.created_at ? moment(item.created_at).format(displayDateFormatShort) : '--'}</TableCell>
            <TableCell>
                {days === null ?
                    <Chip size='small' label='Never logged in' style={{background:'#FBF3DD', color:'#B8860B', fontWeight:600}} />
                    :
                    <div>
                        <div>{moment(item.last_login).format(displayDateFormatShort)}</div>
                        <div style={{fontSize:'11px', color: days > 90 ? '#C0392B' : '#6E6E7A', fontWeight: days > 90 ? 600 : 400}}>
                            {days === 0 ? 'Today' : days === 1 ? '1 day ago' : `${days} days ago`}
                        </div>
                    </div>
                }
            </TableCell>
            <TableCell>
                <Chip size='small' label={status.label} style={{background:status.bg, color:status.color, fontWeight:600}} />
            </TableCell>
             {checkPermission('settings', 'manage_user','U') ?
                <TableCell style={{position: 'sticky', right: 0, backgroundColor: 'inherit', zIndex: 1, minWidth:'140px', whiteSpace:'nowrap'}}>
                    {item?.is_active && !item?.is_new_user ?
                       <Button onClick={(e) => { e.stopPropagation(); onDeactivate(item); }} color='primary' size='small' variant='contained' style={{whiteSpace:'nowrap'}}>Deactivate</Button>
                        : null
                    }
                </TableCell>: null
            }
        </TableRow>
    )
}
export default ActiveList;
